module.exports = __webpack_public_path__ + "img/mute2.b45d5f4a.png";